import {dotPath} from '@modifi/utilities'
import {selectInputFieldNamesBySectionName} from '../../../../modules/input-fields'
import {
  aEnsureCompanyRegistrationByExternalId,
  selectCompanyRegistration,
  selectCompanyRegistrationIsLoading,
} from '../../../../data/company-registration'
import {SECTION_REGISTRATION_NUMBERS} from '../../../../constants/sections'
import {fieldNameToProperty} from '../utils'
import {AppThunkAction} from '../../../../types/redux'

export const selectInitialRegistrationNumbersFormData = (
  state: Record<string, any>
): Record<string, any> => {
  const companyRegistration = selectCompanyRegistration(state)
  const inputFields = selectInputFieldNamesBySectionName(state, SECTION_REGISTRATION_NUMBERS)

  return inputFields.reduce((result, inputField) => {
    // eslint-disable-next-line no-param-reassign
    result[inputField] = dotPath(fieldNameToProperty(inputField), companyRegistration)
    return result
  }, {} as Record<string, any>)
}

export const selectInitialRegistrationNumbersFormDataIsLoading = (
  state: Record<string, any>,
  externalCompanyId: string
): boolean =>
  selectCompanyRegistration(state)?.externalId !== externalCompanyId &&
  selectCompanyRegistrationIsLoading(state)

export const aInitializePage =
  (externalCompanyId: string): AppThunkAction<Promise<void>> =>
  async (dispatch): Promise<void> => {
    if (externalCompanyId) {
      dispatch(aEnsureCompanyRegistrationByExternalId(externalCompanyId))
    }
  }
